export default __webpack_public_path__ + "locales/lo-LA/EmbeddingPanel.json?hash=f13caaecedc3d67dfc4e627ec40a49ac";